import styled, { css } from 'styled-components';
import { FlexContainer, Text, Accordion } from '@taxdown/piccolo-web';
import { BoxModes } from 'Types/common';

const boxModesStyles = {
  [BoxModes.notStarted]: css`
    background: ${({ theme: { colors } }) => colors.white};
    p {
      color: ${({ theme: { colors } }) => colors.dark_500};
    }
  `,
  [BoxModes.lastStep]: css`
    background: ${({ theme: { colors } }) => colors.sky_200};
    p {
      color: ${({ theme: { colors } }) => colors.sky_500};
    }
  `,
  [BoxModes.paid]: css`
    background: ${({ theme: { colors } }) => colors.green_200};
    p {
      color: ${({ theme: { colors } }) => colors.green_800};
    }
  `,
};

export const Header = styled(FlexContainer)`
  height: auto;
`;

export const Gain = styled(FlexContainer)`
  height: auto;
`;

export const Box = styled(FlexContainer)`
  border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_L};
  padding: ${({ theme: { sizing } }) => sizing.fds_size_24};
  width: 310px;
  height: fit-content;
  min-height: 265px;
  border: 1px solid ${({ theme: { colors } }) => colors.sky_300};
  gap: ${({ theme: { sizing } }) => sizing.fds_size_24};
  ${({ mode }) => boxModesStyles[mode]};
`;

export const EmptyContainer = styled(FlexContainer)`
  flex-wrap: wrap;
  gap: ${({ theme: { sizing } }) => sizing.fds_size_24};
`;

export const EmptyImage = styled.img`
  width: 192px;
  height: 120px;
`;

export const InviteLink = styled.button`
  cursor: pointer;
  p {
    color: ${({ theme: { colors } }) => colors.green_600};
  }
`;

export const EmptyTitle = styled(Text)`
  height: 30px;
`;

export const FriendsListAccordion = styled(Accordion)`
  margin: 0;

  p {
    color: ${({ theme: { colors } }) => colors.dark_500};
  }

  ${InviteLink} {
    p {
      color: ${({ theme: { colors } }) => colors.green_600};
    }
  }

  .accordion-parent {
    border: none;
  }

  .accordion-parent__trigger > div {
    padding: 0;
  }

  .accordion-parent__contentInner {
    margin: ${({ theme: { sizing } }) => sizing.fds_size_32} 0 0;
  }
`;
